export class ZAccordionService {
    constructor() {
    }
    // public async attach(): Promise<any> {
    // Events.observeOnce(EVENT_TYPE.ON_LOAD, () => this.handlePageLoad())
    // }
    initHandlers($comp) {
        const $accordions = $comp.find('.accordions');
        $accordions.toArray().map(e => $(e)).map($accordion => this.setupAccordion($comp, $accordion));
    }
    setupAccordion($comp, $container) {
        const $accordions = $container.find('.accordion');
        $accordions.click(e => {
            e.preventDefault();
            const $clicked = $(e.target).closest('.accordion');
            const $active = $container.find('.accordion.active');
            if (!$clicked.is($active)) {
                $active.toggleClass('active');
            }
            $clicked.toggleClass('active');
            const $panel = $comp.find('.accordions .accordion.active+.panel');
            $comp.find('.accordions .panel').toArray().map(e => $(e)).map($p => {
                $p.css('max-height', ($p.is($panel)) ? $panel.prop('scrollHeight') + 'px' : '');
            });
        });
    }
}
//# sourceMappingURL=accordion.js.map